import React from 'react'

export default function Layouts400() {
  return (
    <section><a className="anchor" id="badrequest"></a>
      <div className="push--bottom grid">
          <div className="grid__col-sm-12  grid__col-lg-6">
              <a href="samples/badrequest.html"><img src="images/badrequest.png" alt="Screenshot of the theme snippet" className="media__img"/></a>
          </div>
          <div className="media__body soft--top grid__col-sm-12 grid__col-lg-6">
            <h2>400 Error</h2>
            <p>Live example of all the 400 error page.</p>
            <p><a className="btn btn--large" href="samples/badrequest.html">View live preview</a>&nbsp;<a className="btn btn--large" href="samples/badrequest.html" download>Download</a></p>
          </div>
      </div>
    </section>
  )
}



// WEBPACK FOOTER //
// ./styleguide/components/sections/Layouts400.js